import * as React from 'react'
import TourModule, { ReactourStep } from 'reactour'

interface Props {
  steps: ReactourStep[]
  isOpen: boolean
  onRequestClose: (...args: any[]) => void
}

export const Tour = ({ steps, isOpen, onRequestClose }: Props) => {
  return (
    <TourModule
      showNumber={false}
      showNavigationNumber={false}
      closeWithMask={false}
      showCloseButton={false}
      showButtons={false}
      maskSpace={0}
      steps={steps}
      isOpen={isOpen}
      onRequestClose={onRequestClose} />
  )
}
